var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 24,
    height: 24,
    transform: "translate(217 121)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-217 -121)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(215.286 119.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M13.714,20.571,8.494,13.2a6.977,6.977,0,0,1,5.22-11.486,6.926,6.926,0,0,1,6.857,6.969,7.029,7.029,0,0,1-1.543,4.4Zm0-17.143A5.2,5.2,0,0,0,8.571,8.683a5.306,5.306,0,0,0,1.277,3.429l3.866,5.477L17.683,12a5.349,5.349,0,0,0,1.174-3.317,5.2,5.2,0,0,0-5.143-5.254Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(12 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M24,10.286H22.286V12H24V24H3.429V12H5.143V10.286H3.429A1.714,1.714,0,0,0,1.714,12V24a1.714,1.714,0,0,0,1.714,1.714H24A1.714,1.714,0,0,0,25.714,24V12A1.714,1.714,0,0,0,24,10.286Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.214f9fa946c34daf238fe08c2396951a.svg";
export { ForwardRef as ReactComponent };